import styled from "@emotion/styled";
import { sdkTouchOptimizedStyles } from "scmp-sdk/components/follow-button/styles";

import CloseIcon from "./icon-close.svg";

export const StyledCloseButton = styled(CloseIcon)`
  position: absolute;
  inset-block-start: -10px;
  inset-inline-end: -10px;

  inline-size: 24px;
  block-size: 24px;
  padding: 4px;

  border-radius: 50%;

  background-color: #222222;

  cursor: pointer;

  ${sdkTouchOptimizedStyles}
`;
